<template>
  <modal v-model="model" max-width="600">
    <template #title>{{ title }}</template>
    <template #content>
      <template v-if="!hasError">
        <div v-if="allZero" class="text-center py-4">
          <v-icon x-large color="warning">info</v-icon>
          <div class="mt-2">
            No references were matched — check you uploaded the
            EndNote XML and its matching PDF ZIP for this review.
          </div>
        </div>
        <v-row v-else no-gutters justify="center" class="mt-3">
          <div
            class="mr-4 mb-4 d-flex flex-column text-center result-bucket"
          >
            <v-icon x-large color="success">check_circle</v-icon>
            Matched
            <div class="text-h4">
              <strong>{{ numberOfMatched }}</strong>
            </div>
            <div class="caption grey--text text--darken-2">
              PDF matched to a screened-in reference
            </div>
          </div>
          <div
            class="mr-4 mb-4 d-flex flex-column text-center result-bucket"
          >
            <v-icon x-large color="warning">remove_circle</v-icon>
            Unmatched
            <div class="text-h4">
              <strong>{{ numberOfUnmatched }}</strong>
            </div>
            <div class="caption grey--text text--darken-2">
              No screened-in reference for this record
            </div>
          </div>
          <div
            class="mr-4 mb-4 d-flex flex-column text-center result-bucket"
          >
            <v-icon x-large color="error">error</v-icon>
            Invalid
            <div class="text-h4">
              <strong>{{ numberOfInvalid }}</strong>
            </div>
            <div class="caption grey--text text--darken-2">
              Record missing title or abstract
            </div>
          </div>
          <div
            v-if="numberOfNoPdf > 0"
            class="mr-4 mb-4 d-flex flex-column text-center result-bucket"
          >
            <v-icon x-large color="grey">block</v-icon>
            No PDF
            <div class="text-h4">
              <strong>{{ numberOfNoPdf }}</strong>
            </div>
            <div class="caption grey--text text--darken-2">
              Record had no PDF in the ZIP
            </div>
          </div>
          <div
            v-if="numberOfFailedUploads > 0"
            class="mb-4 d-flex flex-column text-center result-bucket"
          >
            <v-icon x-large color="error">cloud_off</v-icon>
            Failed
            <div class="text-h4">
              <strong>{{ numberOfFailedUploads }}</strong>
            </div>
            <div class="caption grey--text text--darken-2">
              PDF found but upload failed — you can retry
            </div>
          </div>
        </v-row>
      </template>
      <div v-else no-gutters class="text-center">
        <v-icon x-large color="error">sentiment_dissatisfied</v-icon>
        <div class="error--text">
          {{ error }}
        </div>
      </div>
    </template>
    <template #actions>
      <action-button class="mr-2" @click="model = false">
        Close
      </action-button>
      <action-button
        v-if="!hasError"
        color="primary"
        @click="startReview"
      >
        Start Full Text Review
      </action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';

export default {
  name: 'BulkUploadResultDialog',
  components: { ActionButton, Modal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    numberOfMatched: {
      type: Number,
      default: 0,
    },
    numberOfUnmatched: {
      type: Number,
      default: 0,
    },
    numberOfInvalid: {
      type: Number,
      default: 0,
    },
    numberOfNoPdf: {
      type: Number,
      default: 0,
    },
    numberOfFailedUploads: {
      type: Number,
      default: 0,
    },
    error: {
      type: String,
      default: null,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    title() {
      return this.hasError
        ? 'Bulk Upload Failed'
        : 'Bulk Upload Complete';
    },
    hasError() {
      return this.error !== null;
    },
    allZero() {
      return (
        this.numberOfMatched === 0 &&
        this.numberOfUnmatched === 0 &&
        this.numberOfInvalid === 0 &&
        this.numberOfNoPdf === 0 &&
        this.numberOfFailedUploads === 0
      );
    },
  },
  methods: {
    startReview() {
      this.model = false;
      this.$emit('start-review');
    },
  },
};
</script>

<style scoped>
.result-bucket {
  width: 100px;
}
</style>
